module.exports = __webpack_public_path__ + "img/bl.30d6b24.svg";